import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class MarbleDisplay extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, type) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, `mm_common_assets/Marble${type}`);

    this.setOrigin(0);

    this.marbleType = type;
    this.origX = null;
    this.origY = null;
    this.body = null;

    this.isGrabbed = false;
    this.grabbedMarbleRef = null;

    this.offsetX = 0;
    this.offsetY = 0;
  }
}